import { CreditCardModel } from './../../models/creditCard.model';
import { ResponsibleModel } from '../../models/responsible.model';
import { ResponsibleService } from '../../services/responsible.service';
import { NotificationService } from '../../notification/swal/notification.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.less']
})
export class CreditCardComponent implements OnInit {

  creditCards: Array<CreditCardModel> = new Array<CreditCardModel>();
  responsible: ResponsibleModel = new ResponsibleModel();
  creditCardAlreadySearched = false;

  constructor(private router: Router, private responsibleService: ResponsibleService, private notificationService: NotificationService) { }

  ngOnInit() {
    this.getCreditCards();
  }

  private getCreditCards() {
    this.responsibleService.getCreditCards()
    .then((creditCards) => {
      this.creditCards = creditCards;
      this.creditCardAlreadySearched = true;
    })
    .catch((err) => {
      this.creditCardAlreadySearched = true;
      this.notificationService.showErrorNotification(err.message);
    });
  }


  goToRegisterCreditCard() {
    this.router.navigate(['general/registrarCartao']);
  }

  private deleteCreditCard(id) {
    this.responsibleService.deleteCreditCard(id)
    .then((_creditCard) => {
      this.notificationService.showSuccessNotification('Cartão deletado com sucesso!')
        .then(() => this.getCreditCards());
    })
    .catch((err) => {
      this.notificationService.showErrorNotification(err.message);
    });
  }

  delete(creditCard: CreditCardModel) {
    this.notificationService.showQuestionNotification('Você deseja excluir esse cartão?')
      .then(result => {
        if (result.value) {
          this.deleteCreditCard(creditCard);
        }
      });

  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/credit-card/credit-card.component.ts